<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
    			<!-- <div class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"> -->
            <div class="md-layout-item">
    				<!-- <h3>Congratulations!</h3> -->
              <h4>您剛掃描了 Spaces Go 的條碼，歡迎由以下連結下載 Spaces Go。</h4>
              <h4>You have just scanned the QR code of Spaces Go. Welcome to download Spaces Go by the link below.</h4>
              <br>              
                <a href="https://play.google.com/store/apps/details?id=com.viainno.spacesgo">
                    <img :src="google_play" />
                </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a href="https://itunes.apple.com/tw/app/spaces-go/id1444387614">
                    <img :src="app_store" />
                </a>
            </div>
            
        </div>
      </div>
    </parallax>    
  </div>
</template>

<script>
export default {
  bodyClass: "profile-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/0040030-PS2.jpg")
    },
    app_store: {
      type: String,
      default: require("@/assets/img/logo/app_store2x.png")
    },
    google_play: {
      type: String,
      default: require("@/assets/img/logo/google_play2x.png")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
          //background: ` url(${this.header}) center center`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
h2{
  margin: 0 0 8px 0;
  line-height: 1em
}
h4{
  margin: 0 0   30px 0;
}
.container
{
  color: rgb(74,74,74) !important
}
a img{
  height: 40px;
}
</style>
